import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classnames from 'classnames';
import styles from './content.scss';
export let ALIGNMENT = /*#__PURE__*/function (ALIGNMENT) {
  ALIGNMENT["LEFT"] = "left";
  ALIGNMENT["CENTER"] = "center";
  ALIGNMENT["RIGHT"] = "right";
  return ALIGNMENT;
}({});
export class Content extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      isClient: false
    });
    _defineProperty(this, "handleContentClick", event => {
      const {
        onClick
      } = this.props;
      event.preventDefault();
      event.stopPropagation();
      onClick();
    });
  }
  componentDidMount() {
    if (typeof window !== 'undefined') {
      this.setState({
        isClient: true
      });
    }
  }
  renderPublisher() {
    const {
      publisher,
      isRTL,
      publisherClassName
    } = this.props;
    if (!publisher) {
      return null;
    }
    const publisherClassNames = classnames(styles.publisher, publisherClassName, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    return /*#__PURE__*/React.createElement("div", {
      className: publisherClassNames,
      "data-hook": "publisher"
    }, publisher);
  }
  renderTitle() {
    const {
      title,
      isRTL,
      titleClassName,
      isOptimalFontSizes
    } = this.props;
    if (!title) {
      return null;
    }
    const titleClassNames = classnames(styles.title, titleClassName, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL,
      [styles.optimalFontSize]: isOptimalFontSizes
    });
    return /*#__PURE__*/React.createElement("h3", {
      key: this.state.isClient ? 'title-client' : 'title-ssr',
      className: titleClassNames,
      title: title,
      "data-hook": "title"
    }, title);
  }
  renderDescription() {
    const {
      description,
      isRTL,
      textClassName,
      isOptimalFontSizes
    } = this.props;
    if (!description) {
      return null;
    }
    const descriptionClassNames = classnames(styles.description, textClassName, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL,
      [styles.optimalFontSize]: isOptimalFontSizes
    });
    return /*#__PURE__*/React.createElement("div", {
      key: this.state.isClient ? 'description-client' : 'description-ssr',
      className: descriptionClassNames,
      "data-hook": "description"
    }, description);
  }
  render() {
    const {
      className,
      isFocusable,
      alignment,
      isRTL
    } = this.props;
    const containerClassNames = classnames(styles.container, {
      [styles['align-left']]: alignment === ALIGNMENT.LEFT,
      [styles['align-center']]: alignment === ALIGNMENT.CENTER,
      [styles['align-right']]: alignment === ALIGNMENT.RIGHT,
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    const contentClassNames = classnames(styles.content, className, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    return /*#__PURE__*/React.createElement("div", {
      className: containerClassNames
    }, /*#__PURE__*/React.createElement("a", {
      href: "#",
      className: contentClassNames,
      onClick: this.handleContentClick,
      tabIndex: isFocusable ? 0 : -1,
      "aria-hidden": !isFocusable
    }, this.renderPublisher(), this.renderTitle(), this.renderDescription()));
  }
}
_defineProperty(Content, "defaultProps", {
  alignment: ALIGNMENT.LEFT,
  isOptimalFontSizes: true
});
//# sourceMappingURL=content.js.map